import { forwardRef, Icon, IconProps } from '@chakra-ui/react';
import { useIconId } from '../utils';

const BitbucketBlue = forwardRef<IconProps, 'svg'>((props, ref) => {
  const iconPrefix = useIconId();
  return (
    <Icon ref={ref} viewBox="0 0 16 16" {...props}>
      <path
        d="M1.44942 1.69995C1.16969 1.69995 0.959884 1.95638 1.0065 2.21281L2.89475 13.7754C2.94137 14.0785 3.1978 14.2882 3.50085 14.2882H12.639C12.8489 14.2882 13.0353 14.1251 13.082 13.9153L14.9935 2.23612C15.0402 1.95638 14.8303 1.72327 14.5506 1.72327L1.44942 1.69995ZM9.46867 10.0455H6.55468L5.78538 5.91938H10.1913L9.46867 10.0455Z"
        fill="#2684FF"
      />
      <path
        d="M14.3641 5.91938H10.168L9.46867 10.0455H6.55468L3.12783 14.1251C3.12783 14.1251 3.29101 14.265 3.52413 14.265H12.6623C12.8721 14.265 13.0586 14.1018 13.1052 13.8919L14.3641 5.91938Z"
        fill={`url(#${iconPrefix}__a)`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${iconPrefix}__a`}
          x1={15.3456}
          x2={8.39201}
          y1={7.08207}
          y2={12.5101}
        >
          <stop offset={0.176} stopColor="#0052CC" />
          <stop offset={1} stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
});

export default BitbucketBlue;
